import { IApplicationState } from '../../types/redux';

export const workplaceCountValueSelector = (state: IApplicationState) => {
  return state.filters.jsonQuery.workplace_count?.value || {};
};
